<template>
  <a-modal
    title="编辑路线"
    :confirm-loading="confirmLoading"
    @ok="confirm"
    v-model="show"
    :width="700"
    :afterClose="
      () => {
        $emit('close');
      }
    "
  >
    <a-form-model ref="form" :model="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
      <a-form-model-item label="物流服务" prop="service_name" :rules="[{ required: true, message: '请输入' }]">
        <a-input v-model="form.service_name" />
      </a-form-model-item>
      <a-form-model-item label="详情" prop="detail">
        <a-input v-model="form.detail" />
      </a-form-model-item>
      <a-form-model-item label="路线服务" prop="service">
        <a-checkbox-group v-model="form.service">
          <a-checkbox value="货到付款" name="serve">货到付款</a-checkbox>
          <a-checkbox value="不含增值税" name="serve">不含增值税</a-checkbox>
          <a-checkbox value="自送网点" name="serve">自送网点</a-checkbox>
          <a-checkbox value="上门取件" name="serve">上门取件</a-checkbox>
        </a-checkbox-group>
      </a-form-model-item>
      <a-form-model-item label="货到付款售价" prop="buy_price">
        <a-input style="width: 224px;" addon-after="€" v-model="form.buy_price" />
      </a-form-model-item>
      <a-form-model-item label="货到付款进价">
        <div class="inputGroup">
          <a-input addon-before="大于100" addon-after="€" v-model="form.sale_price.lt100" />
          <a-input addon-before="小于100" addon-after="€" v-model="form.sale_price.gt100" />
        </div>
      </a-form-model-item>

      <a-form-model-item label="跳转链接" prop="point">
        <a-input v-model="form.point" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import Service from '@/api/service';
export default {
  name: 'line_EditModal',
  props: {
    show: Boolean,
    detail: Object,
    options: Array,
    service_id: String,
  },
  data() {
    return {
      confirmLoading: false,
      Visible: false,
      form: {
        service_name: '',
        detail: '',
        service: [],
        buy_price: '',
        sale_price: {
          lt100: '',
          gt100: '',
        },
        point: '',
      },
    };
  },
  computed: {
    isEdit() {
      return this.detail.id ? true : false;
    },
  },
  watch: {
    detail(res) {
      this.form.id = res.id;
      this.form.line = res.line;
      this.form.company = res.company;
      this.form.service_name = res.service_name;
      this.form.detail = res.detail || '';
      this.form.service = res.service;
      this.form.buy_price = res.buy_price || '';
      this.form.sale_price = res.sale_price || { lt100: '', gt100: '' };
      this.form.url = res.url || '';
    },
  },
  created() {},
  methods: {
    confirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.confirmLoading = true;
          Service.setService(this.form)
            .then(res => {
              this.confirmLoading = false;
              if (res.code == 0) {
                this.$emit('close');
                this.$emit('success');
                this.$message.success(res.msg);
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch(res => {
              this.confirmLoading = false;
            });
        }
      });
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.inputGroup {
  display: flex;
  .ant-input-group-wrapper {
    margin-right: 20px;
  }
}
</style>
